export default {
      id: "league-gold-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#league-gold",
      toString: function () {
        return this.url;
      }
    }